export const STORE_REVIEW_ANALYTICS = 'reviewAnalytics';
export const STORE_REVIEW_TOP_HOTELS = 'reviewAnalytics/topHotels';
export const STORE_REVIEW_REVIEWS = 'reviewAnalytics/reviews';

export const GET_REVIEW_ANALYTICS_DATA = 'getReviewAnalyticsData';
export const GET_REVIEW_ANALYTICS_COUNTRIES = 'getReviewAnalyticsCountries';
export const FETCH_REVIEWS_DATA = 'fetchReviewsData';

export const FETCH_TOP_HOTELS_DATA = 'fetchTopHotelsData';
export const GET_TOP_HOTELS_DATA = 'getTopHotelsData';
